import { RMap } from "../../collections";
import { makeImmutable } from "../../core";
export class ScheduleParameterMultiSet {
    constructor(values) {
        this.values = values;
        makeImmutable(this);
    }
    static empty() {
        return new ScheduleParameterMultiSet(RMap.empty());
    }
    get isEmpty() {
        return this.values.isEmpty;
    }
    get unavailableValues() {
        return this.values.filterByValues((v) => v.some((v) => !v));
    }
    union(other) {
        return new ScheduleParameterMultiSet(this.values.unionWithKey(other.values, (_, a, b) => a.union(b)));
    }
    intersection(other) {
        const intersection = this.values
            .intersectionWithKey(other.values, (_, a, b) => a.intersection(b))
            .filterByValues((v) => !v.isEmpty);
        return new ScheduleParameterMultiSet(intersection);
    }
}
